module.exports = __webpack_public_path__ + "img/7B.68c2db78.png";